import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { valueFormatter } from '@plato/ui-legacy/lib/chart-helpers';
import { useResolvedLocale } from '@plato/ui-legacy/lib/hooks/locale';

export function useChartYAxisWidth() {
    const locale = useResolvedLocale();
    const { defaultCurrency } = useAppConfig();

    const testText = valueFormatter(0, locale, defaultCurrency);

    const yAxisWidth = testText.length > 2 ? 100 : 80;

    return { yAxisWidth };
}
